<template>
  <section>
    <div class="food-footer-bottom pt-30 pb-30 black-bg-5 mt-5">
      <div class="food-widget-content">
        <ul>
          <li @click="clickItem">
            <router-link to="/widgetpolicy"> Privacy Policy</router-link>
          </li>
          <li @click="clickItem">
            <router-link to="/widgetterms">Terms of Use</router-link>
          </li>
          <li @click="clickItem">
            <router-link to="/widgetsupport">Contact</router-link>
          </li>
        </ul>
      </div>
    </div>

    <div class="food-copyright black-bg-6 ptb-30">
      <div class="container text-center">
        <p>Copyright &copy; {{ yearTime }} Aesthetic Widgets</p>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  data() {
    return {
      yearTime: new Date().getFullYear()
    };
  },
  methods: {
    clickItem() {
      window.scrollTo(0, 0);
    }
  }
};
</script>
<style lang="scss" scoped>
.food-widget-content,
ul {
  @include flex-center;
}
.food-widget-content ul li {
  margin-bottom: 0 !important;
  margin: 16px;
}
</style>
